export const ASSESSMENT_LIBRARY_CONTENT = "assessment-library-content";
export const ONLY_INITIAL_EVALUATION_FILTER_TEXT = "Initial assessment only";
export const BOTH_EVALUATION_FILTER_TEXT = "Initial and follow-up assessment";
export const REBA_SCORE_WORST_RANGE_TEXT = "11+";
export const REBA_SCORE_VERY_BAD_RANGE_TEXT = "7-10";
export const REBA_SCORE_BAD_RANGE_TEXT = "5-6";
export const REBA_SCORE_OK_RANGE_TEXT = "3-4";
export const REBA_SCORE_EXCELLENT_RANGE_TEXT = "1-2";
